/**
 * WraparoundsStore
 * Extends the BaseStore for managing Wraparounds.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { WraparoundInterface } from '@sah/Classes/Wraparound';

class WraparoundsStore extends BaseStore<WraparoundInterface> {}

export default new WraparoundsStore();
